import styled from "styled-components";
import { ReactComponent as FacebookIconLink } from "../SvgIcons/facebookIcon.svg";
import { ReactComponent as InstagramIconLink } from "../SvgIcons/instagramIcon.svg";
import { ReactComponent as BookingIconLink } from "../SvgIcons/bookingIcon.svg";
import { ReactComponent as Codify } from "./codify.svg"
import { ReactComponent as Czorsztynianka } from "./logo-czorsztynianka.svg"
import { Link as RouterLink } from "react-router-dom";

export const FooterSection = styled.footer`
    background: #93A981;
    padding: 20px;
    padding-bottom: 40px;
    text-align: center;
    margin-top: 60px;

`;

export const FooterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    grid-gap: 24px;
`;

export const FooterLogo = styled(Czorsztynianka)`
    height: 150PX;
    width: 150px;
    color: white;
`;

export const FooterIcons = styled.div`
    display: flex;
    gap: 15px;

    @media (max-width: 768px) {
        gap: 16px;
}
`;

export const FacebookIcon = styled(FacebookIconLink)`
    width: 48px;
    height: 48px;
    color: white;
    transition: color 0.3s;

        &:hover {
        color: #ddd;
    }
`;

export const InstagramIcon = styled(InstagramIconLink)`
    width: 48px;
    height: 48px;
    color: white;
    transition: color 0.3s;

        &:hover {
        color: #ddd;
    }
`;

export const BookingIcon = styled(BookingIconLink)`
    width: 48px;
    height: 48px;
    color: white;
    transition: color 0.3s;

        &:hover {
        color: #ddd;
    }
`;

export const FooterCopyright = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    gap: 10px;
    line-height: 1.2;
    font-size: 18px;
`;

export const HomeButton = styled.button`
    background: #93A981;
    color: white;
    border: 1px solid transparent;
    border-radius: 4px 4px 0 0;
    margin: 0 auto;
    padding: 10px;
    position: relative;
    top: -61px;
    cursor: pointer;

          svg {
    width: 40px;
    height: 40px;
    vertical-align: middle;
  }

    &:hover {
    background: #7d966d;
  }
`;

export const CodifyLogo = styled(Codify)`
  width: 35px;
  height: auto;
  transition: transform 0.5s ease-out;
`;

export const FooterCredit = styled.a`
  color: inherit;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  transition: color 0.3s ease;

  &:hover {
    color: #ddd;
  }

&:hover ${CodifyLogo} {
    transform: rotate(45deg);
  }
`;

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;

export const PolicyLink = styled(RouterLink)`
    text-decoration: none;
    color: white;
    transition: color 0.3s;

        &:hover {
        color: #ddd;
    }
`;